import { collection, getDocs, addDoc, updateDoc, query, where } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import { db, functions } from '../../firebase';

// Get notification settings for a given user
export const getNotificationSettings = async (employeeId) => {
  try {
    const ref = collection(db, 'notificationSettings');
    const q = query(ref, where('eid', '==', employeeId));
    const querySnapshot = await getDocs(q);
    const data = {};
    querySnapshot.forEach((n) => {
      const { type, enabled } = n.data();
      data[type] = enabled;
    });
    return data;
  } catch (error) {
    console.error('Error fetching notification settings:', error);
    throw error;
  }
};

// Sync notifications settings for a given user
export const submitNotificationSettings = async (employeeId, settings = {}) => {
  try {
    const ref = collection(db, 'notificationSettings');

    for (const [key, value] of Object.entries(settings)) {
      const q = query(ref, where('eid', '==', employeeId), where('type', '==', key));
      const result = await getDocs(q);

      if (!result.empty) {
        await updateDoc(result.docs[0].ref, { enabled: value })
      } else {
        await addDoc(ref, { eid: employeeId, type: key, enabled: value });
      }
    }
    return settings;
  } catch (error) {
    console.error('Error saving notification settings:', error);
    throw error;
  }
};

// List all user claims
export const listUserRoles = async (userId, venueId) => {
  try {
    const getRoles = httpsCallable(functions, 'listUserRoles');
    const { data } = await getRoles({ userId, venueId });
    if (data.success) return data.data;
  } catch (error) {
    console.error('Error reading user roles:', error);
  }
  return {};
};
